// 실제 크롤러(scripts/crawlNotices.js)는 모든 공지에 category: '통합공지'만 부여하므로
// '장학' 카테고리 exact match로는 장학 공지를 찾을 수 없다. 구조화된 필드 우선,
// 없으면 제목 키워드, 그래도 없으면 본문/키워드까지 보는 3단계 fallback으로 분류한다.

const SCHOLARSHIP_CATEGORY_KEYWORDS = ['장학', '학생지원', '학사']
const SCHOLARSHIP_TITLE_KEYWORDS = ['장학', '장학금', '국가장학', '교내장학', '교외장학', '학자금']

export const normalizeForSearch = (value) => String(value ?? '').toLowerCase().replace(/\s+/g, '')

function hasStructuredScholarshipMatch(notice) {
  if (notice?.resolverKey === 'notices.scholarship') return true
  const category = normalizeForSearch(notice?.category)
  if (!category) return false
  return SCHOLARSHIP_CATEGORY_KEYWORDS.some(k => category.includes(normalizeForSearch(k)))
}

function hasTitleScholarshipMatch(notice) {
  const title = normalizeForSearch(notice?.title)
  if (!title) return false
  return SCHOLARSHIP_TITLE_KEYWORDS.some(k => title.includes(normalizeForSearch(k)))
}

function hasGeneralScholarshipMatch(notice) {
  const keywords = Array.isArray(notice?.keywords) ? notice.keywords : []
  const haystack = normalizeForSearch([notice?.title, notice?.content, ...keywords].filter(Boolean).join(' '))
  if (!haystack) return false
  return SCHOLARSHIP_TITLE_KEYWORDS.some(k => haystack.includes(normalizeForSearch(k)))
}

export function isScholarshipNotice(notice) {
  return hasStructuredScholarshipMatch(notice) || hasTitleScholarshipMatch(notice) || hasGeneralScholarshipMatch(notice)
}

// 우선순위: 구조화된 category/resolverKey → 제목 키워드 → 본문/키워드 fallback.
// 상위 단계에서 1건이라도 찾으면 그 결과를 사용하고, 못 찾으면 다음 단계로 넘어간다.
export function filterScholarshipNotices(notices) {
  const list = Array.isArray(notices) ? notices : []
  const structured = list.filter(hasStructuredScholarshipMatch)
  if (structured.length > 0) return structured
  const byTitle = list.filter(hasTitleScholarshipMatch)
  if (byTitle.length > 0) return byTitle
  return list.filter(hasGeneralScholarshipMatch)
}
